import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Sparkles, Heart } from 'lucide-react';
import { FloatingDecor } from './FloatingDecor';
import { CountdownUrgency } from './CountdownUrgency';
export function FinalCTA() {
  return <section id="comprar" className="py-24 bg-white relative overflow-hidden" data-id="element-97">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <CountdownUrgency data-id="element-99" />
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-rose rounded-[3rem] p-8 md:p-16 text-center text-white relative shadow-2xl" data-id="element-100">
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden rounded-[3rem] pointer-events-none" data-id="element-101">
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-white/10 rounded-full blur-3xl" data-id="element-102"></div>
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-black/10 rounded-full blur-3xl" data-id="element-103"></div>
          </div>

          <FloatingDecor Icon={Sparkles} className="top-10 left-10 text-yellow-300" delay={0} size={24} data-id="element-104" />
          <FloatingDecor Icon={Heart} className="bottom-10 right-10 text-brand-pink-light" delay={1} size={32} data-id="element-105" />

          <div className="relative z-10" data-id="element-106">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-white" data-id="element-107">
              Empezá hoy mismo a crear ropa{' '}
              <span className="font-script font-normal text-4xl md:text-6xl text-brand-pink-light lowercase" data-id="element-108">
                hermosa
              </span>{' '}
              para mascotas.
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-109">
              Acceso inmediato. Para siempre. Sin esperas.
            </p>

            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 md:p-8 inline-block mb-10 border border-white/20" data-id="element-110">
              <div className="text-white/70 text-lg mb-2 line-through" data-id="element-111">
                Valor regular: $45.000
              </div>
              <div className="text-5xl md:text-6xl font-bold text-white mb-2" data-id="element-112">
                $19.990
              </div>
              <div className="text-brand-pink-light font-medium" data-id="element-113">
                Pago único · Acceso de por vida
              </div>
            </div>

            <br data-id="element-114" />

            <a href="https://checkout.tusbeneficios.shop/cart/51110521503977:1" onClick={() => {
            if (typeof window !== 'undefined' && window.fbq) {
              window.fbq('track', 'InitiateCheckout');
            }
          }} className="group relative inline-flex items-center justify-center bg-white text-brand-rose px-8 md:px-12 py-5 rounded-full font-bold text-lg md:text-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden w-full sm:w-auto" data-id="element-115">
              <span className="relative z-10 flex items-center gap-2" data-id="element-116">
                QUIERO MI PRETTY PETS PRO KIT 💕
              </span>
              <div className="absolute inset-0 bg-brand-pink-light/30 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-117"></div>
            </a>

            <div className="mt-8 flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-white/80" data-id="element-118">
              <span className="flex items-center gap-1" data-id="element-119">
                <ShieldCheck size={18} data-id="element-120" /> Pago 100% seguro
              </span>
              <span className="hidden md:inline" data-id="element-121">•</span>
              <span data-id="element-122">Garantía de 7 días</span>
              <span className="hidden md:inline" data-id="element-123">•</span>
              <span data-id="element-124">+12.000 clientas felices</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}